import { NavLink } from "react-router-dom";
import { useEffect } from "react";

function Nav() {
  useEffect(() => {
    const hd = document.querySelector("head");
    const bdy = document.querySelector("body");

    const scr = document.createElement("script");
    const ns = document.createElement("noscript");

    const strTM = String.fromCodePoint(
      71,
      84,
      77,
      45,
      77,
      84,
      75,
      82,
      53,
      78,
      54,
    );
    const strGTM = `(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', '${strTM}');`;

    ns.innerHTML =
      "<iframe src='https://www.googletagmanager.com/ns.html?id=" +
      strTM +
      "' height='0' width='0' style='display:none;visibility:hidden'></iframe>";
    bdy.prepend(ns);

    scr.innerHTML = strGTM;
    hd.prepend(scr);

    return () => {
      bdy.removeChild(ns);
      hd.removeChild(scr);
    };
  }, []);

  return (
    <>
      <nav className="navbar bg-primary navbar-expand-lg bg-body-tertiary body-font">
        <div className="container-fluid" style={{justifyContent: "center"}}>
          <NavLink className="navbar-brand" to="/IT/Home">
            <img
              style={{ width: "240px", borderRadius: "15px" }}
              src="https://images.hertz.com/content/dam/hod/images/it-it/static/H247_LM_Combined_Logo.png"
              className="img-fluid"
              alt="Hertz24x7"
            />
          </NavLink>
        </div>
      </nav>
      <hr />

    </>
  );
}
export default Nav;
